/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

interface EventHistorySpeedIconProps {
  size?: IconSize | number;
  color?: string;
}

/*
 * Defines the Design Language System (DLS) Event History Speed Icon component for the
 * Event Popup.
 */
export const EventHistorySpeedIcon = ({size = 16, color = dlsColor('grey3')}: EventHistorySpeedIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <line x1="1.99316" y1="3.77173" x2="4.53236" y2="3.77173" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="1.99316" y1="10.8145" x2="4.53236" y2="10.8145" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="0.75" y1="7.29352" x2="3.82776" y2="7.29352" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7.65014 1.01818C12.04 0.725526 15 4.01326 15 7.74923C15 11.4852 12.04 14.773 7.65015 14.4804" stroke={color} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M14.8721 7.75006L13.4984 7.75006" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M11.3286 4.41631L8.83013 6.98737" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M7.81494 1.00031L7.81494 2.37396" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M7.81494 13.0776L7.81494 14.4985" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M11.3668 11.6573L12.3413 12.6266" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M7.6301 7.66814C7.6301 7.24158 7.97589 6.89578 8.40245 6.89578C8.82901 6.89578 9.1748 7.24158 9.1748 7.66814C9.1748 8.0947 8.82901 8.44049 8.40245 8.44049C7.97589 8.44049 7.6301 8.0947 7.6301 7.66814Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  );
};
